export default __webpack_public_path__ + "static/media/Brookvale Iced Tea - proportioned_170.92564c46.jpg";